module.exports = __webpack_public_path__ + "static/media/73.d14b5b5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/73.jpg
// module id = 632
// module chunks = 0